import { Component, input, output, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgClass, TitleCasePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IUser } from '@shs-digi-care-monorepo/interfaces';
import { Comment } from '../../../models';
import { LocalizedDatePipe } from '../../../pipes/localized-date.pipe';

/**
 * Displays a single comment bubble.
 * Mirrors the current user's comments to the right, others to the left.
 */
@Component({
    selector: 'app-comment-bubble',
    templateUrl: './comment-bubble.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [LocalizedDatePipe, NgClass, TitleCasePipe, TranslateModule]
})
export class CommentBubbleComponent {
    public comment = input.required<Comment>();
    public currentUser = input<IUser | null>(null);
    public referralName = input<string | null>(null);

    /** Emits { commentId, fileName } when the user clicks a file attachment */
    public fileDownload = output<{ commentId: string; fileName: string }>();

    protected get isMine(): boolean {
        return this.comment().createdBy?.gid === this.currentUser()?.gid;
    }

    protected get initials(): string {
        const { firstName, lastName } = this.comment().createdBy ?? {};
        return `${firstName?.[0] ?? ''}${lastName?.[0] ?? ''}`.toUpperCase();
    }

    protected onFileClick(fileName: string): void {
        this.fileDownload.emit({ commentId: this.comment().id, fileName });
    }
}
